import * as Sentry from '@sentry/vue';

export default defineNuxtPlugin((nuxtApp) => {
  const sentryDsn = useRuntimeConfig().public.sentryDsn;

  if (!sentryDsn) {
    return;
  }

  // Nuxt turns any Vue error into the fatal error page and drops that handler once the app
  // has booted — but only if it is still the very same function (nuxt/dist/app/entry.js:46-50).
  // Sentry.init() replaces config.errorHandler and keeps Nuxt's behind it, so the check fails
  // and from then on even a failed click wipes the whole app. Keep that behaviour for the boot.
  const bootErrorHandler = nuxtApp.vueApp.config.errorHandler;

  nuxtApp.vueApp.config.errorHandler = (error, instance, info) => {
    if (nuxtApp.isHydrating && bootErrorHandler) {
      return bootErrorHandler.call(nuxtApp.vueApp, error, instance, info);
    }

    console.error('[vue]', error);
  };

  Sentry.init({
    app: nuxtApp.vueApp,
    // autoSessionTracking: true,
    dsn: sentryDsn,
    // debug: true,
    integrations: [
      Sentry.vueIntegration({
        app: nuxtApp.vueApp,
        trackComponents: true,
        hooks: ['activate', 'create', 'destroy', 'mount', 'update'],
      }),
      Sentry.browserTracingIntegration({
        router: nuxtApp.$router,
        // tracePropagationTargets: [config.public.SENTRY_TRACE_PROPAGATION_TARGET],
      }),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
        maskAllInputs: false,
        useCompression: false,
        networkDetailAllowUrls: [
          useRequestURL().origin,
          useApi.getBaseURL(),
        ],
      }),
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.3,
    ignoreErrors: ['ResizeObserver loop limit exceeded'],

    replaysSessionSampleRate: 1.0,
    replaysOnErrorSampleRate: 1.0,
  });

  return {
    provide: {
      sentry: Sentry,
      replay: Sentry.getClient()?.getIntegrationByName?.('Replay') || Sentry.getClient()?.getIntegration?.(Sentry.replayIntegration),
    },
  };
});
